import { clsx } from 'clsx';
import * as React from 'react';
import { useGetIsMobileDevice } from '../../hooks';
import * as styles from './ProgressBar.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProgressBarComponent = props => {
  const {
    progress
  } = props;
  const progressBar = React.useRef(null);
  const isMobileDevice = useGetIsMobileDevice();
  React.useEffect(() => {
    if (progressBar.current) {
      progressBar.current.style.background = "conic-gradient(white ".concat(progress * 3.6, "deg, #9da7be 0deg)");
    }
  }, [progress]);
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles['progress'], isMobileDevice && styles['mobile']),
    ref: progressBar,
    children: /*#__PURE__*/_jsx("div", {
      className: clsx(styles['inner'], isMobileDevice && styles['mobile'])
    })
  });
};
export const ProgressBar = /*#__PURE__*/React.memo(ProgressBarComponent);